<template>
  <div class="footer">
    <slot></slot>
  </div>
</template>


<script>
export default {
  name: 'YFooter'
}
</script>

<style lang='scss' scoped>

</style>